module.exports = __webpack_public_path__ + "img/bg_aibiz.a459046c.png";